import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const OverAllReviews = () => {
  return (
    <div className="bg-completedProject py-10">
      <div className="container mx-auto">
        <div className="flex justify-between items-center w-full px-3 lg:px-1">
          <p className="lg:text-4xl text-lg whitespace-nowrap text-black font-semibold">
            Reviews
          </p>
          <div className="flex border border-color rounded-lg p-3 lg:justify-start">
            <p className="text-black lg:text-lg text-sm">
              March 2023 - February 2024
            </p>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col justify-between mt-20">
          <div className="lg:border-r lg:border-b-0 pb-3 lg:pb-0  border-b border-color lg:w-1/3 flex justify-center lg:justify-start">
            <div className="text-center lg:text-start">
              <p className="text-black text-lg font-light">Total Reviews</p>
              <p className="text-5xl whitespace-nowrap py-3 mt-4 text-black font-semibold">
                3000+
              </p>
              <p className="text-black text-sm">
                Growth in reviews on this year
              </p>
            </div>
          </div>
          <div className="lg:border-r border-b lg:border-b-0 py-3 lg:py-0 border-color flex justify-center lg:w-1/3">
            <div className="text-center lg:text-start">
              <p className="text-black text-lg font-light">Average Rating</p>
              <div className="flex gap-2">
                <p className="text-5xl whitespace-nowrap py-3 mt-4 text-black font-semibold">
                  5.0
                </p>
                <div className="flex">
                  {Array(5)
                    .fill(0)
                    .map((_, index) => (
                      <div key={index} className="flex items-end mb-4">
                        <StaticImage
                          placeholder="blurred"
                          className="w-5"
                          src="./star.png"
                          alt="stars"
                        />
                      </div>
                    ))}
                </div>
              </div>
              <p className="text-black text-sm">Average rating on this year</p>
            </div>
          </div>
          <div className="lg:w-1/3 pt-3 flex justify-center">
            <div className="w-1/2">
              <div className="w-full flex justify-center">
                <StaticImage
                  placeholder="blurred"
                  className="w-full"
                  src="./average-reviews.png"
                  alt="reviews"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
